export default __webpack_public_path__ + "static/media/sukuna.b5de9c8b.jpg";